import React from 'react'
import OutwaredBinReportTable from '../../Comman/OutwaredBinReportTable'

const BinStatus = () => {
    return (
        <>
            <OutwaredBinReportTable location={"eol_dispatch"} />
        </>
    )
}

export default BinStatus